import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import React, { FC, memo } from 'react'
import FieldSkeleton from '../../CellLoaders/FieldSkeleton'
import HierarchyCell from '../components/HierarchyCell'
const NoContent: FC<CellItem> = memo(({ rowData }) =>
  !rowData ? (
    <HierarchyCell>
      <FieldSkeleton />
    </HierarchyCell>
  ) : (
    <HierarchyCell>--</HierarchyCell>
  )
)

export default NoContent
